import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  ICompareWordsDto,
  ICompareWordsResponseDto,
  IEvaluateShortAnswerFromTextDto,
  IEvaluateShortAnswerResponseDto,
  IExplainTextDto,
  IExplainTextResponseDto,
  IExtractWordsDto,
  IGenerateQuizFromWordsDto,
  IGenerateShortAnswerFromTextDto,
  IGenerateShortAnswerFromTextResponseDto,
  IGenerateStoryDto,
  IGenerateStoryResponseDto,
  IGetEtymologyDto,
  IGetEtymologyResponseDto,
  IGetTopicWordsDto,
  IGetTopicWordsResponseDto,
  IPromptLLMDto,
  IPromptLLMResponseDto,
  IQuizResponseDto,
  IRephraseSentenceDto,
  IRephraseSentenceResponseDto,
  ITranslateDto,
  ITranslateResponseDto,
  ITranslateWordDto,
  ITranslateWordResponseDto,
} from '@shared';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GeminiApiService {
  readonly #http = inject(HttpClient);

  generateStory(
    payload: IGenerateStoryDto,
  ): Observable<IGenerateStoryResponseDto> {
    return this.#http.post<IGenerateStoryResponseDto>(
      `${environment.apiUrl}/gemini/generate-story`,
      payload,
    );
  }

  getEtymology(
    payload: IGetEtymologyDto,
  ): Observable<IGetEtymologyResponseDto> {
    return this.#http.post<IGetEtymologyResponseDto>(
      `${environment.apiUrl}/gemini/get-etymology`,
      payload,
    );
  }

  prompt(payload: IPromptLLMDto): Observable<IPromptLLMResponseDto> {
    return this.#http.post<IPromptLLMResponseDto>(
      `${environment.apiUrl}/gemini/prompt`,
      payload,
    );
  }

  translateWord(
    payload: ITranslateWordDto,
  ): Observable<ITranslateWordResponseDto> {
    return this.#http.post<ITranslateWordResponseDto>(
      `${environment.apiUrl}/gemini/translate-word`,
      payload,
    );
  }

  compareWords(
    payload: ICompareWordsDto,
  ): Observable<ICompareWordsResponseDto> {
    return this.#http.post<ICompareWordsResponseDto>(
      `${environment.apiUrl}/gemini/compare-words`,
      payload,
    );
  }

  getTopicWords(
    payload: IGetTopicWordsDto,
  ): Observable<IGetTopicWordsResponseDto> {
    return this.#http.post<IGetTopicWordsResponseDto>(
      `${environment.apiUrl}/gemini/topic-words`,
      payload,
    );
  }

  rephraseSentence(
    payload: IRephraseSentenceDto,
  ): Observable<IRephraseSentenceResponseDto> {
    return this.#http.post<IRephraseSentenceResponseDto>(
      `${environment.apiUrl}/gemini/rephrase-sentence`,
      payload,
    );
  }

  translate(payload: ITranslateDto): Observable<ITranslateResponseDto> {
    return this.#http.post<ITranslateResponseDto>(
      `${environment.apiUrl}/gemini/translate`,
      payload,
    );
  }

  explainText(payload: IExplainTextDto): Observable<IExplainTextResponseDto> {
    return this.#http.post<IExplainTextResponseDto>(
      `${environment.apiUrl}/gemini/explain`,
      payload,
    );
  }

  extractWords(
    payload: IExtractWordsDto,
  ): Observable<IGetTopicWordsResponseDto> {
    return this.#http.post<IGetTopicWordsResponseDto>(
      `${environment.apiUrl}/gemini/extract-words`,
      payload,
    );
  }

  generateShortAnswerFromText(
    payload: IGenerateShortAnswerFromTextDto,
  ): Observable<IGenerateShortAnswerFromTextResponseDto> {
    return this.#http.post<IGenerateShortAnswerFromTextResponseDto>(
      `${environment.apiUrl}/gemini/generate-short-answer-exercise`,
      payload,
    );
  }

  evaluateShortAnswerFromText(
    payload: IEvaluateShortAnswerFromTextDto,
  ): Observable<IEvaluateShortAnswerResponseDto> {
    return this.#http.post<IEvaluateShortAnswerResponseDto>(
      `${environment.apiUrl}/gemini/evaluate-short-answer-exercise`,
      payload,
    );
  }

  generateQuiz(
    payload: IGenerateQuizFromWordsDto,
  ): Observable<IQuizResponseDto> {
    return this.#http.post<IQuizResponseDto>(
      `${environment.apiUrl}/gemini/generate-quiz`,
      payload,
    );
  }
}
